/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-10-29 14:46:11 */

const Keys = {
  label: 'label',
  empty: 'empty',
  loading: 'loading',
  error: 'error',
  partialError: 'partialError',
  add: 'add',
  remove: 'remove'
}; export default Keys;